module.exports = __webpack_public_path__ + "static/img/SMSscenario1.5955172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/SMSscenario1.png
// module id = rFab
// module chunks = 0